import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const FAQItem = ({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) => {
  return <div className="border-b border-brand-green/20 last:border-0" data-id="element-78">
      <button onClick={onToggle} className="w-full text-left py-5 flex justify-between items-center focus:outline-none group" data-id="element-79">
        <h4 className="text-base md:text-lg font-serif font-bold text-brand-charcoal group-hover:text-brand-green transition-colors pr-4" data-id="element-80">
          {question}
        </h4>
        <div className={`ml-4 flex-shrink-0 w-6 h-6 rounded-full border border-brand-green flex items-center justify-center transition-transform duration-300 ${isOpen ? 'bg-brand-green text-white rotate-180' : 'text-brand-green'}`} data-id="element-81">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-82">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-83" />
          </svg>
        </div>
      </button>
      <AnimatePresence data-id="element-84">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-85">
            <p className="pb-5 text-brand-charcoal/80 leading-relaxed" data-id="element-86">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Tengo que comprar suplementos caros?',
    answer: 'No. Te enseñamos cuáles funcionan, pero la base es la nutrición informativa que compras en cualquier super.'
  }, {
    question: '¿Funciona si ya pasé la menopausia?',
    answer: 'Sí, los principios de resiliencia metabólica son vitales para la salud ósea y cardiovascular post-menopausia.'
  }, {
    question: '¿Cuánto tiempo necesito al día?',
    answer: 'Entre 15 y 30 minutos al día son suficientes para aplicar los protocolos. Las recetas están diseñadas para prepararse en 15 minutos o menos, y las rutinas de movimiento no superan los 20 minutos.'
  }, {
    question: '¿Es solo un PDF o hay más formatos?',
    answer: 'Recibes el Sistema Principal Paz Hormonal en formato digital junto con todos los bonos y recursos exclusivos incluidos (recetarios, protocolos de emergencia, checklists, etc). Todo está optimizado para que puedas leerlo y aplicarlo fácilmente desde tu móvil, tablet o portátil desde el primer minuto.'
  }, {
    question: '¿Funciona si tomo medicación?',
    answer: 'El sistema se basa en nutrición, hábitos y gestión del estrés — no reemplaza ningún tratamiento médico. Es perfectamente compatible con medicación. Siempre recomendamos consultar con tu médico ante cualquier duda específica.'
  }, {
    question: '¿Puedo acceder desde el móvil?',
    answer: 'Sí, todo el contenido es digital y accesible desde cualquier dispositivo: móvil, tablet u ordenador. Puedes leerlo donde y cuando quieras.'
  }];
  return <section className="py-8 px-4 md:px-8 bg-brand-creamAlt" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-89">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal text-center mb-8" data-id="element-90">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-91">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-92" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}